module.exports = __webpack_public_path__ + "static/media/logo.af6de020.svg";